<template>
  <div id="header" :class="routerClass">
    <div class="wrapper">
      <div class="logo">
        <img
          @click="goToPath(encodeURI('/'))"
          src="@/assets/images/logo.svg"
          alt=""
          style="cursor: pointer"
        />
      </div>
      <div :class="navShow ? 'nav nav-show' : 'nav'">
        <el-menu
          :default-active="menuDefaultActive"
          mode="horizontal"
          router
          @select="handleMenuSelect"
        >
          <el-menu-item index="/">平台首页</el-menu-item>
          <el-menu-item index="/qingbao/list">数据情报</el-menu-item>
          <el-menu-item index="/report/list">发现报告</el-menu-item>
          <el-submenu index="tongjishuju" popper-class="nav-submenu">
            <template slot="title">统计数据</template>
            <!-- <el-menu-item index="/tongji/index?filterTab=2">
              国内宏观数据
            </el-menu-item>
            <el-menu-item index="/tongji/index?filterTab=1">
              国内产量数据
            </el-menu-item>
            <el-menu-item index="/tongji/jinchukou">进出口数据</el-menu-item> -->
            <el-menu-item index="/tongji/hgnd">全国宏观年度库</el-menu-item>
            <el-menu-item index="/tongji/hgyd">全国宏观月度库</el-menu-item>
            <el-menu-item index="/tongji/fsnd">分省宏观年度库</el-menu-item>
            <el-menu-item index="/tongji/fsyd">分省宏观月度库</el-menu-item>
            <el-menu-item index="/tongji/spmy">商品贸易数据库</el-menu-item>
          </el-submenu>
          <el-submenu index="hangyedongcha" popper-class="nav-submenu">
            <template slot="title">行业洞察</template>
            <el-menu-item index="/policy/list">产业政策</el-menu-item>
            <el-menu-item index="/news/list?filterTab=1&keyword=">
              数据快递
            </el-menu-item>
            <el-menu-item index="/news/list?filterTab=2&keyword=">
              国内经济
            </el-menu-item>
            <el-menu-item index="/news/list?filterTab=3&keyword=">
              国际动态
            </el-menu-item>
          </el-submenu>
          <el-submenu index="ziyuandaohang" popper-class="nav-submenu">
            <template slot="title">资源导航</template>
            <el-menu-item index="/nav/industry">产业导航</el-menu-item>
            <el-menu-item index="/nav/company">企业导航</el-menu-item>
            <el-menu-item index="/nav/school">高校导航</el-menu-item>
            <el-menu-item index="/nav/region">区域导航</el-menu-item>
          </el-submenu>
          <!-- <el-menu-item :index="encodeURI('/研报精选')">研报精选</el-menu-item> -->
          <el-menu-item
            class="mvp"
            index="/console/index"
            v-if="
              !$store.state.logined || $store.state.userInfo.workbenchAccess
            "
          >
            <i class="el-icon-edit-outline"></i>我的工作台
          </el-menu-item>
        </el-menu>
        <div class="h5-menu">
          <ul class="el-menu--horizontal el-menu">
            <li @click="goToPath('/')" class="el-menu-item">平台首页</li>
            <li @click="goToPath('/qingbao/list')" class="el-menu-item">
              数据情报
            </li>
            <li @click="goToPath('/report/list')" class="el-menu-item">
              发现报告
            </li>
            <li class="el-submenu">
              <div class="el-submenu__title">
                统计数据<i
                  class="el-submenu__icon-arrow el-icon-arrow-down"
                ></i>
              </div>
              <div class="el-menu--horizontal nav-submenu">
                <ul class="el-menu">
                  <!-- <li
                    @click="goToPath('/tongji/index?filterTab=2')"
                    class="el-menu-item"
                  >
                    国内宏观数据
                  </li>
                  <li
                    @click="goToPath('/tongji/index?filterTab=1')"
                    class="el-menu-item"
                  >
                    国内产量数据
                  </li>
                  <li
                    @click="goToPath('/tongji/jinchukou')"
                    class="el-menu-item"
                  >
                    进出口数据
                  </li> -->

                  <li @click="goToPath('/tongji/hgnd')" class="el-menu-item">
                    全国宏观年度库
                  </li>
                  <li @click="goToPath('/tongji/hgyd')" class="el-menu-item">
                    全国宏观月度库
                  </li>
                  <li @click="goToPath('/tongji/fsnd')" class="el-menu-item">
                    分省宏观年度库
                  </li>
                  <li @click="goToPath('/tongji/fsyd')" class="el-menu-item">
                    分省宏观月度库
                  </li>
                  <li @click="goToPath('/tongji/spmy')" class="el-menu-item">
                    商品贸易数据库
                  </li>
                </ul>
              </div>
            </li>
            <li class="el-submenu">
              <div class="el-submenu__title">
                行业洞察<i
                  class="el-submenu__icon-arrow el-icon-arrow-down"
                ></i>
              </div>
              <div class="el-menu--horizontal nav-submenu">
                <ul class="el-menu">
                  <li @click="goToPath('/policy/list')" class="el-menu-item">
                    产业政策
                  </li>
                  <li
                    @click="goToPath('/news/list?filterTab=1&keyword=')"
                    class="el-menu-item"
                  >
                    数据快递
                  </li>
                  <li
                    @click="goToPath('/news/list?filterTab=2&keyword=')"
                    class="el-menu-item"
                  >
                    国内经济
                  </li>
                  <li
                    @click="goToPath('/news/list?filterTab=3&keyword=')"
                    class="el-menu-item"
                  >
                    国际动态
                  </li>
                </ul>
              </div>
            </li>
            <li class="el-submenu">
              <div class="el-submenu__title">
                资源导航<i
                  class="el-submenu__icon-arrow el-icon-arrow-down"
                ></i>
              </div>
              <div class="el-menu--horizontal nav-submenu">
                <ul class="el-menu">
                  <li @click="goToPath('/nav/industry')" class="el-menu-item">
                    产业导航
                  </li>
                  <li @click="goToPath('/nav/company')" class="el-menu-item">
                    企业导航
                  </li>
                  <li @click="goToPath('/nav/school')" class="el-menu-item">
                    高校导航
                  </li>
                  <li @click="goToPath('/nav/region')" class="el-menu-item">
                    区域导航
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <div
          @click="navShow = !navShow"
          class="nav-menu"
          v-clickoutside="
            () => {
              navShow = false;
            }
          "
        >
          <span class="lcbody">
            <span class="lcitem top">
              <span class="rect top"></span>
            </span>
            <span class="lcitem bottom">
              <span class="rect bottom"></span>
            </span>
          </span>
        </div>
      </div>
      <div class="user-box">
        <template
          v-if="$store.state.logined && $store.state.userInfo.type !== 1"
        >
          <div :class="userNavShow ? 'user-menu is-active' : 'user-menu'">
            <el-badge
              class="user-rank"
              is-dot
              :rank-level="$store.state.userInfo.vipType > 0 ? 1 : 0"
            >
              <el-avatar
                class="user-avatar"
                :src="headPhoto"
                @click.native="userNavShow = !userNavShow"
                v-clickoutside="
                  () => {
                    userNavShow = false;
                  }
                "
              >
                <img :src="avatarUrl" />
              </el-avatar>
              <!-- <el-avatar
                class="user-avatar"
                :src="avatarUrl"
                @click.native="userNavShow = !userNavShow"
                v-clickoutside="
                  () => {
                    userNavShow = false;
                  }
                "
              >
              </el-avatar> -->
            </el-badge>
            <div class="user-menu_content">
              <div class="user-info">
                <el-badge
                  class="user-rank"
                  is-dot
                  :rank-level="$store.state.userInfo.vipType > 0 ? 1 : 0"
                >
                  <el-upload
                    class="avatar-uploader"
                    :action="uplodAction"
                    :show-file-list="false"
                    :headers="uplodHeaders"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload"
                    ref="avatarUploader"
                  >
                    <el-avatar class="user-avatar" :src="headPhoto">
                      <img :src="avatarUrl" />
                    </el-avatar>
                  </el-upload>
                  <!-- <el-avatar class="user-avatar" :src="avatarUrl"></el-avatar> -->
                </el-badge>
                <div class="name" :title="$store.state.userInfo.username">
                  {{
                    $store.state.userInfo.username &&
                    $store.state.userInfo.username.length > 10
                      ? $store.state.userInfo.username.substring(0, 10) + "..."
                      : ""
                  }}
                </div>
                <div class="info">
                  <span>
                    ID:
                    <template>
                      {{ $store.state.userInfo.id }}
                    </template>
                  </span>
                  <span>
                    积分:
                    <template>
                      {{ $store.state.userInfo.integral || 0 }}
                    </template>
                  </span>
                </div>
              </div>
              <div
                class="insert-alert"
                @click="goToPath('/user/vip')"
                v-if="$store.state.userInfo.vipType === 0"
              >
                加入VIP会员 获取更多研报
              </div>
              <div class="insert-alert" v-else>
                {{
                  ($store.state.userInfo.vipType === 1 ? "VIP" : "SVIP") +
                  "到期时间：" +
                  ($store.state.userInfo.vipTime
                    ? dateFormat($store.state.userInfo.vipTime, "YYYY-MM-DD")
                    : "永久有效")
                }}
              </div>
              <div class="user-menu_group">
                <!-- <div class="user-menu_item" @click="goToPath('/user/collect')">
                  我的收藏
                </div> -->
                <div class="user-menu_item" @click="goToPath('/user/jifen')">
                  我的积分
                </div>
                <div class="user-menu_item" @click="goToPath('/user/download')">
                  我的下载
                </div>
                <!-- <div class="user-menu_item" @click="goToPath('/user/upload')">
                  我的上传
                </div> -->
                <div class="user-menu_item" @click="goToPath('/user/order')">
                  我的订单
                </div>
              </div>
              <div class="user-menu_group">
                <!-- <div class="user-menu_item" @click="goToPath('/user/info')">
                  个人资料
                </div>
                <div class="user-menu_item" @click="goToPath('/user/password')">
                  修改密码
                </div>
                <div class="user-menu_item" @click="goToPath('/user/email')">
                  我的邮箱
                </div> -->
                <div
                  class="user-menu_item"
                  @click="handleRedirectSSOUserProfile"
                >
                  个人资料
                </div>
              </div>
              <div class="user-menu_group">
                <div class="user-menu_item" @click="logout">退出登录</div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <!-- <el-button @click="$router.push('/login')" type="text"
            >登录</el-button
          >
          <el-button @click="$router.push('/register')" type="primary"
            >注册</el-button
          > -->
          <el-button
            type="text"
            v-if="$store.state.logined && $store.state.userInfo.type === 1"
            class="organ-name"
            :title="$store.state.userInfo.username"
          >
            {{ $store.state.userInfo.username }}
          </el-button>

          <el-button @click="handleRedirectSSOLogin" type="text">
            登录
          </el-button>
          <el-button @click="handleRedirectSSORegister" type="primary">
            注册
          </el-button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { axiosOptions, axiosRequest } from "../util/request";
import moment from "moment";
import {
  redirectSSOLoginOut,
  redirectSSOLogin,
  redirectSSORegister,
  redirectSSOUserProfile,
} from "../util/utils";

const clickoutside = {
  // 初始化指令
  bind(el, binding, vnode) {
    function documentHandler(e) {
      // 这里判断点击的元素是否是本身，是本身，则返回
      if (el.contains(e.target)) {
        return false;
      }
      // 判断指令中是否绑定了函数
      if (binding.expression) {
        // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
        binding.value(e);
      }
    }
    // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
    el.__vueClickOutside__ = documentHandler;
    document.addEventListener("click", documentHandler);
  },
  update() {},
  unbind(el, binding) {
    // 解除事件监听
    document.removeEventListener("click", el.__vueClickOutside__);
    delete el.__vueClickOutside__;
  },
};

export default {
  directives: { clickoutside },
  props: {
    routerClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      navShow: false,
      userNavShow: false,
      headPhoto: this.$store.state.userInfo.headPhoto,
      avatarUrl: require("@/assets/images/avatar-default.png"),
      searchKeyword: "",
      menuDefaultActive: "",

      uplodAction: `${process.env.VUE_APP_BASE_API}/user/upload-avatar`,
      uplodHeaders: {
        authorization: "Bearer " + localStorage.getItem("token"),
        "x-authorization": "Bearer " + localStorage.getItem("refreshToken"),
      },
    };
  },
  created() {
    // if (!this.ipLogined) {
    //   this.handleiP();
    // }
    this.handleMenuDefaultActive();
  },
  watch: {
    "$route.fullPath"(newFullPath) {
      if (newFullPath.indexOf("policy") > -1) {
        this.menuDefaultActive = "/policy/list";
      } else if (newFullPath.indexOf("/news/list?filterTab=1") > -1) {
        this.menuDefaultActive = "/news/list?filterTab=1&keyword=";
      } else if (newFullPath.indexOf("/news/list?filterTab=2") > -1) {
        this.menuDefaultActive = "/news/list?filterTab=2&keyword=";
      } else if (newFullPath.indexOf("/news/list?filterTab=3") > -1) {
        this.menuDefaultActive = "/news/list?filterTab=3&keyword=";
      } else if (newFullPath.indexOf("console") > -1) {
        this.menuDefaultActive = "/console/list?type=1&listType=0";
      } else {
        this.menuDefaultActive = newFullPath;
      }
    },
  },
  mounted() {},
  methods: {
    handleRedirectSSOLogin() {
      redirectSSOLogin();
    },
    handleRedirectSSORegister() {
      redirectSSORegister();
    },
    handleRedirectSSOUserProfile() {
      redirectSSOUserProfile();
    },
    dateFormat(cellValue, format) {
      if (!cellValue) return "";

      return moment(cellValue).format(format);
    },
    handleAvatarSuccess(res, file) {
      if (res.code == 200) {
        // this.user.HeadPhoto = URL.createObjectURL(file.raw);
        this.getUserInformation();
      } else {
        this.$message.error(res.errors);
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 1;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 png|jpg|jepg 格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 1MB!");
        return false;
      }
    },
    /**获取登录用户信息 */
    getUserInformation() {
      axiosRequest(
        "/user/user-formation",
        { t: Date.now() },
        axiosOptions("get", "", "json")
      ).then((res) => {
        if (res.data && res.data.code == 200) {
          this.headPhoto = res.data.data.headPhotoUrl;

          let userInfo = JSON.parse(localStorage.getItem("userInfo"));
          // userInfo.id = res.data.data.id;
          // userInfo.username = res.data.data.username;
          userInfo.headPhoto = res.data.data.headPhotoUrl;
          localStorage.setItem("userInfo", JSON.stringify(userInfo));
          this.$store.commit("setUserInfo", userInfo);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    handleMenuDefaultActive() {
      const fullPath = this.$route.fullPath;
      if (fullPath.indexOf("policy") > -1) {
        this.menuDefaultActive = "/policy/list";
      } else if (fullPath.indexOf("/news/list?filterTab=1") > -1) {
        this.menuDefaultActive = "/news/list?filterTab=1&keyword=";
      } else if (fullPath.indexOf("/news/list?filterTab=2") > -1) {
        this.menuDefaultActive = "/news/list?filterTab=2&keyword=";
      } else if (fullPath.indexOf("/news/list?filterTab=3") > -1) {
        this.menuDefaultActive = "/news/list?filterTab=3&keyword=";
      } else if (fullPath.indexOf("console") > -1) {
        this.menuDefaultActive = "/console/list?type=1&listType=0";
      } else {
        this.menuDefaultActive = fullPath;
      }
    },
    handleMenuSelect(index, indexPath) {
      this.navShow = false;
    },
    goToPath(path) {
      this.userNavShow = false;
      this.navShow = false;
      this.$router.push(path);
    },
    //退出
    logout: function () {
      this.$confirm("确定注销并退出系统吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          axiosRequest("/tool/login-out", {}, axiosOptions("get", "", "json"))
            .then((res) => {
              if (res.data && res.data.code === 200) {
                localStorage.removeItem("logined");
                localStorage.removeItem("ipLogined");
                localStorage.removeItem("token");
                localStorage.removeItem("userName");
                localStorage.removeItem("userInfo");
                localStorage.removeItem("Keyword");
                localStorage.removeItem("ipLoginRquest");
                this.$store.commit("setLogined", false);
                redirectSSOLoginOut();
                // this.$router.push({ path: "/" }).catch((err) => {});
              } else {
                this.$message.error("注销登录失败，请稍后重试！");
              }
            })
            .catch((err) => {
              console.log(err);
              this.$message.error("注销登录失败，请稍后重试！");
            });
        })
        .catch(() => {});
    },
    personal: function () {
      this.$router.push({ path: "/download_index" }).catch((err) => {});
    },
    handleiP() {
      axiosRequest("/user/ip-login", {}, axiosOptions("get", "", "json")).then(
        (res) => {
          console.log(res);
          if (res.data && res.data.statusCode == 200) {
            localStorage.setItem("ipLogined", true);
            localStorage.setItem("ipUserName", res.data.data.ipUserName);
          } else {
            this.$message.error(res.data.errors);
          }
        }
      );
    },
    /**检索 */
    handleSearch() {
      if (this.Keyword == "") {
        this.$message.error("请输入检索词");
      } else {
        let routeUrl = this.$router.resolve({
          path: "/journal_article_page_index",
          query: { Keyword: this.Keyword },
        });
        window.open(routeUrl.href, "_blank");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .user-menu_content {
  .el-upload {
    .user-avatar {
      img {
        height: 40px;
        width: 40px;
      }
    }
  }
}

.organ-name {
  cursor: default;
  color: #777;
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

<style>
.el-avatar > img {
  width: 100%;
  height: 100%;
}

.nav-submenu {
  width: 135px;
}
</style>
